module.exports = __webpack_public_path__ + "static/img/24087C_1_2_C_20240624_fit.41b52a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/24087C_1_2_C_20240624_fit.png
// module id = rN0Q
// module chunks = 0